(function ($, Drupal, drupalSettings) {
  Drupal.behaviors.tabs = {
    attach: function (context, settings) {
      $('.tabs', context).once('tabs').each(function () {
        var that = $(this);
        var navTab = that.find(".nav-tab");

        navTab.on("click", function (e) {
          e.preventDefault();

          if (!($(this).hasClass("active"))) {
            var target = $(this).attr("href");
            var activePane = that.find(".tab.active");

            navTab.removeClass("active");
            $(this).addClass("active");

            activePane.removeClass("show");
            setTimeout(function () {
              activePane.removeClass("active");
              $(target).addClass("active");

              setTimeout(function () {
                $(target).addClass("show");
              }, 100);
            }, 200);
          }
        });
      });
    }
  }
})(jQuery, Drupal, drupalSettings);
